import React from 'react';

/**
 * Fallback preview for features that don't have a custom preview yet.
 * Pure JSX, no API calls, no context.
 */
export default function GenericPreview({ featureName = 'this feature' }) {
    return (
        <div className="h-full w-full flex items-center justify-center bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-blue-950 p-12">
            <div className="max-w-2xl text-center space-y-6">
                <div className="grid grid-cols-3 gap-3">
                    {Array.from({ length: 9 }).map((_, i) => (
                        <div
                            key={i}
                            className="h-24 rounded-lg bg-white dark:bg-gray-800 shadow-sm border border-gray-200 dark:border-gray-700"
                            style={{ opacity: 1 - (i * 0.08) }}
                        />
                    ))}
                </div>
                <p className="text-gray-500 dark:text-gray-400 font-rasa">
                    A glimpse of what {featureName} looks like in JPRO.
                </p>
            </div>
        </div>
    );
}
